import { useCallback, useState } from 'react';

import {
  CollectionsInsightRenderRegister,
  RendererRegistrationKey,
} from '../../public/CollectionsInsightRendererRegister';
import { CollectionsInsightRenderer, Proposition } from '../../shared/types';

export function useInsightRenderer<TInsightData = unknown>(
  proposition: Proposition,
  type: string
): CollectionsInsightRenderer {
  const [renderer, setRenderer] = useState<CollectionsInsightRenderer<TInsightData>>(null);

  const updateRenderer: (
    registrationKey: RendererRegistrationKey,
    renderer: CollectionsInsightRenderer<TInsightData>
  ) => void = useCallback(
    (registrationKey, registeredRenderer) => {
      if (registrationKey.proposition === proposition && registrationKey.type === type && registeredRenderer) {
        setRenderer(registeredRenderer);
      }
    },
    [proposition, type]
  );

  // ATTENTION: uncommenting this will load the renderer twice, let us check if we can leave it out
  // However this will not allow us to react on a change of proposition or type - which we don't expect anyway
  // useEffect(() => {
  //   setRenderer(null);
  // }, [proposition, type]);

  if (!renderer) {
    // the renderers are registered by the MFEs, however it can happen that MFEs are loaded after the initial render of an insight
    // in this case we register an update callback that triggers if the required renderer becomes available
    const registeredRenderer = CollectionsInsightRenderRegister.getInstance().get<TInsightData>({ proposition, type });
    if (registeredRenderer) {
      setRenderer(registeredRenderer);
    } else {
      CollectionsInsightRenderRegister.getInstance().registerUpdateCallback({ proposition, type }, updateRenderer);
    }
  }

  return (
    renderer ?? {
      InsightRenderer: undefined,
      getInsightInfo: undefined,
    }
  );
}
